import axios from "axios";
import { API_BASE } from "@/lib/apiClient";
import { getAccountToken } from "@/lib/accountStorage";

export function isNormalAccountEndpoint(url) {
  const value = typeof url === "string" ? url.split(/[?#]/, 1)[0] : "";
  return value === "/account" || value.startsWith("/account/");
}

export function addAccountAuthorization(config) {
  if (!isNormalAccountEndpoint(config?.url)) return config;
  const token = getAccountToken();
  if (!token) return config;
  return {
    ...config,
    headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` },
  };
}

const accountApi = axios.create({ baseURL: API_BASE });
accountApi.interceptors.request.use(addAccountAuthorization);

export default accountApi;
